/**
 * Centralised social media configuration — single source of truth.
 * All social links across the site should import from here.
 */

export const SOCIAL_URLS = {
  facebook: 'https://www.facebook.com/PerformanceCarExclusive',
  instagram: 'https://www.instagram.com/performancecarexclusive',
  x: 'https://x.com/perfcarexc',
  youtube: 'https://www.youtube.com/@performancecarexclusive',
} as const;

export const TWITTER_HANDLE = '@perfcarexc';
